import React, { useState } from 'react';
import { MdPictureAsPdf, MdImage } from 'react-icons/md';
import Attention from '../../ReusableComponents/Attention';

export default function FileTypesField({ value }) {
  const [selected, setSelected] = useState(value || ['pdf', 'jpg', 'jpeg', 'png']);
  return (
    <fieldset className="portal-file-types">
      <legend className="form-label">
        Formatos permitidos <Attention />
      </legend>
      <div className="portal-file-types-grid">
        {[
          ['pdf', 'PDF'],
          ['jpg', 'JPG'],
          ['jpeg', 'JPEG'],
          ['png', 'PNG'],
        ].map(([type, label]) => (
          <label
            className={`portal-format-choice ${selected.includes(type) ? 'is-selected' : ''}`}
            key={type}
          >
            <input
              type="checkbox"
              name="allowed_types"
              value={type}
              checked={selected.includes(type)}
              required={!selected.length}
              onChange={(event) => {
                const checked = event.target.checked;
                setSelected((all) =>
                  checked ? [...all, type] : all.filter((item) => item !== type)
                );
              }}
            />
            {type === 'pdf' ? <MdPictureAsPdf /> : <MdImage />}
            <span>{label}</span>
          </label>
        ))}
      </div>
      <small className="form-text">Selecione pelo menos um formato de arquivo.</small>
    </fieldset>
  );
}
